import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
      // primary: "#01777A",
      primary: "#286AB5",
      accent: "#F3BF5F",
      warning: "#F3BF5F",
      secondary: "#4d4d4d",
      },
    },
  },
});
